// AUTO-GENERATED by scripts/generate-build-info.mjs — do not edit by hand.
// Gitignored (see .gitignore). Swapped in for
// src/app/shared/constants/build-info.ts by the `production` and `deployed`
// build configurations' fileReplacements entries in angular.json.
export const BUILD_TIMESTAMP_UTC_MS: number | null = 1787574820803;
export const LAST_MERGED_PR_NUMBER: number | null = 6538;
